import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button} from "react-bootstrap";
import {
    getActiveVenueId,
    getLeadManageParentPath,
    getLeadManageStaticContent, getPartnerAccount,
    getSessionUserId,
    getUserAgent,
} from '../../../App/AppReducer';
import {
    addNewSubPackage, deleteSubPackage,
    fetchLeadDetails,
    fetchPrimaryAssets,
    fetchSubPackageList,
    showFullViewTabVisibleState,
    updateSubPackage
} from '../../LeadManageActions';
import {
    getAddingSubPackageStatus,
    getEditingSubPackageStatus,
    getFetchingSubpackageListStatus,
    getFullViewTabVisiblestate,
    getLeadDetails,
    getLeadLogId,
    getMenuList, getPackages,
    getSelectedLeadId,
    getSubPackageCount,
    getSubPackagePageNum,
    getSubPackagePageSize,
    getSubPackages
} from '../../LeadManageReducer';
import AddPackage from "./components/AddPackage";
import NavBar from "../../components/NavBar";
import {userNotify} from '../../../../components/Toasts/ToastAdd';
import BasicLoader from '../../../../components/Loader/BasicLoader';
import Breadcrumb from '../../components/Beadcrumb';
import {withRoute} from 'util/withRoute';
import _ from 'lodash';
import MobileNavigationBar from "../../components/MobileNavigationBar";
import {Drawer, Modal} from "antd";
import EditPackage from "./components/EditPackage";
import {Helmet} from "react-helmet";
import SwitchControl from "../../../../components/PermissionLocks/SwitchControl";

const MODULE_NAME = 'event';

/* ── inline styles ──────────────────────────────────────── */
const S = {
  page: {
    background: 'transparent',
    padding: '0px',
    marginTop: '0px',
    boxSizing: 'border-box',
  },
  headerRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '16px',
    marginTop: '15px',
  },
  title: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: 0,
  },
  addBtn: {
    background: '#2A52BB',
    border: 'none',
    borderRadius: '10px',
    color: '#fff',
    fontSize: '14px',
    fontWeight: '600',
    padding: '9px 22px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    boxShadow: '0 3px 10px rgba(42,82,187,0.25)',
    width: 'auto',
  },
  cardList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  card: {
    background: '#ffffff',
    border: '1px solid #e8edf5',
    borderRadius: '14px',
    overflow: 'hidden',
  },
  cardTop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 18px',
    borderBottom: '1px solid #f0f3f8',
  },
  cardName: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: 0,
  },
  deleteBtn: {
    width: '30px',
    height: '30px',
    border: '1px solid #e0e5f0',
    borderRadius: '6px',
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#888',
    fontSize: '13px',
    flexShrink: 0,
  },
  menuSection: {
    padding: '10px 18px',
    borderBottom: '1px solid #f0f3f8',
  },
  menuLabel: {
    color: '#1A1A1A',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '8px',
  },
  menuItems: {
    display: 'flex',
    gap: '20px',
    flexWrap: 'wrap',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  menuDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#2A52BB',
    flexShrink: 0,
  },
  menuItemName: {
    fontSize: '13px',
    color: '#555',
    whiteSpace: 'nowrap',
  },
  cardBottom: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 18px',
  },
  price: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#2A52BB',
  },
  editBtn: {
    background: '#fff',
    border: '1px solid #d0d5e8',
    borderRadius: '6px',
    color: '#333',
    fontSize: '13px',
    fontWeight: '500',
    padding: '5px 18px',
    cursor: 'pointer',
  },
};

class PackageListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuList: [],
            packageList: [],
            addPackage: {},
            editPackage: {},
            isShowSelectPackage: false,
            isShowAddPackage: false,
            isShowEditPackage: false,
            selectedPackagesToMail: [],
            showPackageDeleteModal: false,
            packageId: ''
        };
    }

    componentDidMount() {
        this.handleDispatch();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.leadid !== this.props.leadid ||
            prevProps.lead._id !== this.props.lead._id ||
            prevProps.venueid !== this.props.venueid ||
            prevProps.lead.event !== this.props.lead.event) {
            this.handleDispatch();
        }
    }

    handleDispatch() {
        let leadId = this.props?.leadid ? this.props?.leadid : this.props?.lead._id ? this.props?.lead._id : '';
        let eventId = this.props?.lead?.event ? this.props?.lead.event : '';
        let venueId = this.props?.venueid ? this.props?.venueid : '';
        let filters = {};
        filters.pageNum = this.props.pageNum;
        filters.pageSize = this.props.pageSize;
        if(!_.isEqual(leadId)){
            this.props.dispatch(fetchLeadDetails(leadId));
        }
        if(!_.isEqual(venueId)){
            this.props.dispatch(fetchPrimaryAssets(venueId));
        }
        if(eventId && venueId && !_.isEqual(venueId) && !_.isEqual(eventId)){
            this.props.dispatch(fetchSubPackageList(eventId, venueId));
        }
    }

    handleOpenAddPackageOverlay    = () => this.setState({ isShowSelectPackage: false, isShowAddPackage: true,  isShowEditPackage: false });
    handleCloseAddPackageOverlay   = () => this.setState({ isShowAddPackage: false });
    handleOpenSelectPackageOverlay = () => this.setState({ isShowSelectPackage: true,  isShowAddPackage: false, isShowEditPackage: false });
    handleCloseSelectPackageOverlay= () => this.setState({ isShowSelectPackage: false });
    handleOpenEditPackageOverlay   = (editPackage) => this.setState({ isShowSelectPackage: false, isShowAddPackage: false, isShowEditPackage: true, editPackage });
    handleCloseEditPackageOverlay  = () => this.setState({ isShowEditPackage: false });

    showMessage = (msg, type) => { userNotify(msg, type); };

    handleAddNewSubPackage = (newPackage) => {
      console.log(newPackage, this.props.lead, "BDJHQBWDKQWBDKJQWBDKJQWBDJKBQWKDBQWJDQ")
        try {
            if(this.props.lead._id && this.props.lead.bundle && this.props.venueid && newPackage) {
                this.props.dispatch(addNewSubPackage(this.props.lead.event, this.props.lead.bundle, this.props.venueid, newPackage));
            }
        } catch (e) { console.log(e); }
    };

    handleSelectAddPackage = (addPackage) => this.setState({ isShowSelectPackage: false, isShowAddPackage: true, isShowEditPackage: false, addPackage });

    handleUpdatePackage = (updatePackage) => {
        this.props.dispatch(updateSubPackage(updatePackage._id, updatePackage, this.props.logId, this.props.agent));
    };

    handleSelectPackageToMail = (id) => {
        let list = [...this.state.selectedPackagesToMail];
        if (list.indexOf(id) > -1) list = list.filter(i => i !== id);
        else list.push(id);
        this.setState({ selectedPackagesToMail: list });
    };

    handleOpenDeleteModal  = (packageId) => this.setState({ showPackageDeleteModal: true, packageId });
    handleCloseDeleteModal = () => this.setState({ showPackageDeleteModal: false });

    handleDeleteConfirm = () => {
        try {
            this.handleRemoveSubPackage(this.state.packageId);
            this.handleCloseDeleteModal();
        } catch (e) { console.log(e); }
    };

    handleRemoveSubPackage = (packageId) => {
        try {
            this.props.dispatch(deleteSubPackage(packageId, this.props.logId, this.props.agent));
        } catch (e) { console.log(e); }
    };

    sendMailToSelectedPackages = () => console.log('Write function to send');
    sendSmsToSelectedPackages  = () => console.log('Write function to send');
    handleShowFullView = (val) => { this.props.dispatch(showFullViewTabVisibleState(val)); };

    render() {
        let drawerContent, staticContent = this.props.staticContent ? this.props.staticContent : {};
        let breakpoint = 800;
        const isMobile = this.props.windowWidth <= 768;

        const titleStyle = {
            ...S.title,
            fontSize: isMobile ? '18px' : '20px',
        };

        const cardTopStyle = {
            ...S.cardTop,
            padding: isMobile ? '12px 12px' : '14px 18px',
        };

        const cardBottomStyle = {
            ...S.cardBottom,
            padding: isMobile ? '12px 12px' : '12px 18px',
        };

        const menuSectionStyle = {
            ...S.menuSection,
            padding: isMobile ? '10px 12px' : '10px 18px',
        };

        if (this.state.isShowAddPackage) {
            drawerContent = <AddPackage
                windowWidth={this.props.windowWidth}
                breakpoint={breakpoint}
                venueId={this.props.venueid}
                showMessage={this.showMessage}
                staticContent={staticContent}
                package={this.state.addPackage}
                eventId={this.props.lead.event}
                leadId={this.props.lead._id}
                isAddingSubPackage={this.props.isAddingSubPackage}
                addPackage={this.handleAddNewSubPackage}
                menu={this.props.menuList}
                packages={this.props.packages || []}
                dispatch={this.props.dispatch}
                lead={this.props.lead}
                handleCloseAddPackageOverlay={this.handleCloseAddPackageOverlay}
            />;
        }
        if (this.state.isShowEditPackage) {
            drawerContent = <EditPackage
                windowWidth={this.props.windowWidth}
                breakpoint={breakpoint}
                showMessage={this.showMessage}
                staticContent={staticContent}
                package={{...this.state.editPackage}}
                eventId={this.props.lead.event}
                isUpdatingSubPackage={this.props.isUpdatingSubPackage}
                updatePackage={this.handleUpdatePackage}
                menu={this.props.menuList}
                handleCloseEditPackageOverlay={this.handleCloseEditPackageOverlay}
            />;
        }
        const segment = (
          <div className="col-sm-12" style={S.page}>
          
            {/* ── Header ── */}
            <div style={S.headerRow}>
              <h5 style={titleStyle}>{staticContent.PACKAGE_LIST_PAGE_TITLE || 'Packages'}</h5>

              <Modal title='Delete Package' open={this.state.showPackageDeleteModal}
                onOk={this.handleDeleteConfirm} onCancel={this.handleCloseDeleteModal}>
                <p>Are you sure you want to delete the package</p>
              </Modal>

              <SwitchControl
                shouldHavePermissions={['leads:edit']}
                userPermissions={this.props.partneraccount.permissions || []}
                yes={
                  <button className="btn-primary-custom" onClick={this.handleOpenAddPackageOverlay}>
                    + {staticContent.PACKAGE_LIST_PAGE_ADD_PACKAGE_BUTTON_TEXT || 'Add Package'}
                  </button>
                }
                no={
                  <button className="btn-primary-custom" disabled>
                    + {staticContent.PACKAGE_LIST_PAGE_ADD_PACKAGE_BUTTON_TEXT || 'Add Package'}
                  </button>
                }
              />
            </div>
<div> {this.props.packageList.length < 1 && <div>No Packages</div> }</div>
            {/* ── Package cards ── */}
            {this.props.packageList && this.props.packageList.length > 0 ? (
              <div style={S.cardList}>
                {this.props.packageList.map((item) => (
                  <div key={item._id} style={S.card}>

                    {/* Top row: name + delete */}
                    <div style={cardTopStyle}>
                      <span style={S.cardName}>{_.startCase(item.name)}</span>
                      <SwitchControl
                        shouldHavePermissions={['leads:edit']}
                        userPermissions={this.props.partneraccount.permissions || []}
                        yes={
                          <button style={S.deleteBtn} onClick={() => this.handleOpenDeleteModal(item._id)}>✕</button>
                        }
                        no={
                          <button style={{...S.deleteBtn, opacity: 0.4, cursor: 'not-allowed'}} disabled>✕</button>
                        }
                      />
                    </div>

                    {/* Menu items (if any) */}
                    {item.menuItems && item.menuItems.length > 0 && (
                      <div style={menuSectionStyle}>
                        <div style={S.menuLabel}>Menu</div>
                        <div style={S.menuItems}>
                          {item.menuItems.map((menuItem) => (
                            <div key={menuItem._id} style={S.menuItem}>
                              <div style={S.menuDot} />
                              <span style={S.menuItemName}>{menuItem.name}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Bottom row: price + edit */}
                    <div style={cardBottomStyle}>
                      <span style={S.price}>₹{item.package_price} /–</span>
                      <SwitchControl
                        shouldHavePermissions={['leads:edit']}
                        userPermissions={this.props.partneraccount.permissions || []}
                        yes={
                          <button style={S.editBtn} onClick={() => this.handleOpenEditPackageOverlay(item)}>
                            {staticContent.PACKAGE_LIST_PAGE_PACKAGE_EDIT_BUTTON_TEXT || 'Edit'}
                          </button>
                        }
                        no={
                          <button style={{...S.editBtn, opacity: 0.4, cursor: 'not-allowed'}} disabled>
                            {staticContent.PACKAGE_LIST_PAGE_PACKAGE_EDIT_BUTTON_TEXT || 'Edit'}
                          </button>
                        }
                      />
                    </div>

                  </div>
                ))}
              </div>
            ) : null}

          </div>
        );

        return (
            <div className="row lead-manage-page"
                style={{ padding: this.props.windowWidth > breakpoint ? '10px 30px' : '10px', marginTop: '0px' }}>
                <Helmet><title>Package List</title></Helmet>

                <Drawer
                    placement={this.props.windowWidth > 768 ? 'right' : 'bottom'}
                    open={this.state.isShowEditPackage || this.state.isShowAddPackage}
                    onClose={() => { this.handleCloseEditPackageOverlay(); this.handleCloseAddPackageOverlay(); }}
                    width={this.props.windowWidth > 768 ? 420 : '100%'}
                    height="50%"
                    className={this.props.windowWidth <= 768 ? 'mobile-override-drawer' : 'web-package-drawer'}
                    title={null}
                    closable={false}
                    bodyStyle={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%', backgroundColor: '#ffffff' }}
                >
                    {drawerContent}
                </Drawer>

                <div
                    className={this.props.isFullViewTabvisible && this.props.windowWidth > breakpoint ? "lead-manage-body-wrapper" : ""}
                    style={{
                        border: this.props.windowWidth < breakpoint ? 'none' : '',
                        height: this.props.windowWidth > breakpoint ? '80vh' : undefined,
                        overflow: this.props.windowWidth > breakpoint ? 'auto' : undefined
                    }}
                >
                    {this.props.isFetchingSubPackage ? (
                        <div style={{ minHeight: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <BasicLoader size={14} />
                        </div>
                    ) : segment}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        leadid: props.params?.leadid,
        leadId: getSelectedLeadId(state),
        venueid: getActiveVenueId(state),
        currentUrl: props.location?.pathname,
        staticContent: getLeadManageStaticContent(state),
        pageSize: getSubPackagePageSize(state),
        pageNum: getSubPackagePageNum(state),
        count: getSubPackageCount(state),
        packageList: getSubPackages(state),
        menuList: getMenuList(state),
        lead: getLeadDetails(state),
        logId: getLeadLogId(state),
        agent: getUserAgent(state),
        userId: getSessionUserId(state),
        isAddingSubPackage: getAddingSubPackageStatus(state),
        isUpdatingSubPackage: getEditingSubPackageStatus(state),
        isFetchingSubPackage: getFetchingSubpackageListStatus(state),
        isLeadManageFromLeadList: getLeadManageParentPath(state),
        packages: getPackages(state),
        partneraccount: getPartnerAccount(state),
        isFullViewTabvisible: getFullViewTabVisiblestate(state),
    };
}

PackageListPage.propTypes = { router: PropTypes.object };
export default connect(mapStateToProps)(withRoute(PackageListPage));